module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "paraspaceabove"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEW YORK UNIVERSITY PRESS")]), _c('br'), _vm._v("New York and London"), _c('br'), _vm._v("www.nyupress.org")]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("© 2007 by New York University"), _c('br'), _vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("Dallam, Marie W."), _c('br'), _vm._v("Daddy Grace : a celebrity preacher and his house of prayer/"), _c('br'), _vm._v("Marie W. Dallam."), _c('br'), _vm._v("p. cm."), _c('br'), _vm._v("Includes bibliographical references and index."), _c('br'), _vm._v("ISBN-13: 978-0-8147-2010-3 (cloth : alk. paper)"), _c('br'), _vm._v("ISBN-10: 0-8147-2010-2 (cloth : alk. paper)"), _c('br'), _vm._v("1. United House of Prayer for All People. 2. Grace, Daddy,"), _c('br'), _vm._v("1882?–1960. I. Title."), _c('br'), _vm._v("BX8777.6.A4D35 2007"), _c('br'), _vm._v("289.9’4—dc22 2007023496")]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability.")]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("Manufactured in the United States of America"), _c('br'), _vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59637c98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04.vue
// module id = 69
// module chunks = 0